import * as React from 'react';
import { CashbackConfig, GameTag } from '../../../http/protocol';
import { IncludeExcludeModeSelector } from './IncludeExcludeModeSelector';
import { GameTagSelector } from './GameTagSelector';

interface Props {
  cashbackConfig?: CashbackConfig;
  gameTags: GameTag[];
  selectedGameTags: GameTag[];
  onModeChange: (excluded: boolean) => void;
  onGameTagsChange: (selectedTags: GameTag[]) => void;
  loading?: boolean;
}

export const GameTagsSection: React.FC<Props> = ({
  cashbackConfig,
  gameTags,
  selectedGameTags,
  onModeChange,
  onGameTagsChange,
  loading = false
}) => {
  return (
    <div className="card-box">
      <div className="ibox-content">
        <h4 className="ibox-title">Game Tags To Exclude/Include</h4>
        <span>
          Configure game tags that should be included or excluded to/from the cashback/rakeback run.
        </span>
        <div className="hr-line-dashed"></div>

        <IncludeExcludeModeSelector
          cashbackConfig={cashbackConfig}
          onModeChange={onModeChange}
        />

        <div className="hr-line-dashed"></div>

        <GameTagSelector
          gameTags={gameTags}
          selectedGameTags={selectedGameTags}
          onSelectionChange={onGameTagsChange}
          disabled={loading}
        />
      </div>
    </div>
  );
};
